import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'data-entry-left-nav',
  template: require('./data-entry-left-nav.component.html'),
  styles: [require('./data-entry-left-nav.component.scss')],
})
export class DataEntryLeftNavComponent {
  @Input() currentRoute: string;
  @Output() changeView: EventEmitter<any> = new EventEmitter<any>();

  public routeOptions = ['Assessments'];

  constructor() {
    // empty block
  }

  public updateView(selection: string): void {
    this.changeView.emit(selection);
  }
}
